import store from './store';
import { IAddressesState } from '../details/addresses/addressesState';
import { AddressesActions } from '../details/addresses/addressesActions';
import { CardsActions } from '../details/paymentMethods/cards/cardsActions';
import { ICardsState } from '../details/paymentMethods/cards/cardsState';
import { PageId } from '../config/constants/pageId.enum';
import { ICancelMembershipState } from '../details/cancelMembership/cancelMemberState';
import { CancelMembershipActions } from '../details/cancelMembership/cancelmembershipActions';
import { IAccountSecurityState } from '../details/accountSecurity/accountSecurityState';
import AccountSecurityActions from '../details/accountSecurity/accountSecurityActions';
import IdentityVerificationActions from '../details/identityVerification/identityVerificationActions';
import { IIdentityVerificationState } from '../details/identityVerification/identityVerificationState';
import { IPrivacyCenterState } from '../details/privacyCenter/privacyCenterState';
import { privacyCenterActions } from '../details/privacyCenter/privacyCenter.actions';

export default class OverlayHelper {
    public static closeHelper(page: PageId) {
        if (page === PageId.address || page === PageId.address_jp) {
            OverlayHelper.addressCloseHelper();
        }

        if (page === PageId.cards) {
            OverlayHelper.paymentCloseHelper();
        }

        if (page === PageId.cancel_membership) {
            OverlayHelper.cancelMembershipCloseHelper();
        }

        if (page === PageId.profile) {
            OverlayHelper.accountSecurityCloseHelper();
        }
        if (page === PageId.ekyc) {
            OverlayHelper.identityVerificationCloseHelper();
        }
        if (page === PageId.ucrm) {
            OverlayHelper.privacyCenterCloseHelper();
        }
    }

    private static cancelMembershipCloseHelper() {
        const cancelMembershipState = store.getState().cancelMembership as ICancelMembershipState;
        if (cancelMembershipState && cancelMembershipState.cancelMembershipOverlayOpen) {
            store.dispatch(CancelMembershipActions.closeCancelMembershipOverlay());
        }
    }

    private static addressCloseHelper() {
        const addressState = store.getState().addresses as IAddressesState;
        if (addressState && addressState.formOpen) {
            store.dispatch(AddressesActions.closeForm());
        }

        if (addressState && addressState.updatedSuccess) {
            store.dispatch(AddressesActions.hiddenUpdatedSuccessInfo());
        }
    }

    private static paymentCloseHelper() {
        const cardsState = store.getState().cards as ICardsState;
        if (cardsState && cardsState.formOpen) {
            store.dispatch(CardsActions.closeForm());
        }
    }

    private static accountSecurityCloseHelper() {
        const accountSecurityState = store.getState().accountSecurity as IAccountSecurityState;
        if (accountSecurityState && accountSecurityState.overlayOpen) {
            store.dispatch(AccountSecurityActions.closeAccountSecurityOverlay());
        }
    }

    private static identityVerificationCloseHelper() {
        const identityVerificationState = store.getState()
            .identityVerification as IIdentityVerificationState;
        if (identityVerificationState && identityVerificationState.overlayOpen) {
            store.dispatch(IdentityVerificationActions.closeIdentityVerificationOverlay());
        }
    }

    private static privacyCenterCloseHelper() {
        const privacyCenterState = store.getState().privacyCenter as IPrivacyCenterState;
        if (privacyCenterState && privacyCenterState.dsrFormOpen) {
            store.dispatch(privacyCenterActions.closeDSRForm());
        }
    }
}
